// extracted by mini-css-extract-plugin
export default {"tableControls":"TableControls_tableControls__3CpoE"};